<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
// import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Invoice Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // ModelListSelect,
    // Loader,
  },
  data() {
    return {
      title: "Invoice Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Invoices",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
    
      data:{
        id: atob(this.$route.params.id),
      }

    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("invoices", ["Invoice","SaveStatus"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Invoice ? this.Invoice.length : 1;
    },
    

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Invoice ? this.Invoice.length : 1;
  },
  updated() {
    
  },
 
  methods: {
    ...mapActions({
      FetchInvoice: "invoices/fetchInvoice",
      
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    


  },
  created() {
    this.FetchInvoice(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="invoice-title">
              <!-- <center> -->
                <div class="row">
                <div class="col-4"></div>
                <div class="col-8 ml-5">
                  <span class=" font-size-18"><strong>{{Invoice ? Invoice.business.name : ""}}</strong></span><br/>
              <span class=" font-size-16">{{Invoice ? Invoice.branch.address : ""}}</span><br/>
              <span class=" font-size-16"><strong>Tel:</strong> {{Invoice?Invoice.contacts: ""}}</span><br/>
              <span class=" font-size-16"><strong>Email:</strong> {{Invoice ? Invoice.branch.email : "---"}}</span><br/>
              </div>
              </div>
              <!-- <span class=" font-size-16"><strong>{{Invoice.invoice_number}}</strong></span><br/> -->
              <!-- <h4 class="float-center font-size-16">Invoice Number # {{Invoice.invoice_number}}</h4> -->
              <!-- </center> -->
              <div class="mb-2">
               
                  
                <!-- <center><h5>CUSTOMER INVOICE</h5></center> -->
                <!-- <img
                  src="@/assets/images/logo-dark.png"
                  alt="logo"
                  height="20"
                /> -->
              </div>
            </div>
            <span class="font-size-16">CUSTOMER INVOICE</span>
            <hr />
            <div class="row">
              <div class="col-6">
                <address>
                  <strong>Customer:</strong>
                 {{ Invoice.customer }} <br />
                </address>
              </div>
              <div class="col-6">
                <address>
                  <strong>Date:</strong>
                   :{{Invoice.date}} <br />
                   <strong>Invoice Number:</strong>  {{ Invoice.invoice_number }} 
                </address>
              </div>
            
            </div>
            
            <hr />
            <div class="p-2 mt-0">
              <h3 class="font-size-16">Order summary</h3>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 70px">No.</th>
                    <th>Product</th>
                    <th>Quantity</th>
                    <th class="text-sm-end">Price</th>
                    <th class="text-sm-end">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(pdt, index) in Invoice?Invoice.all:'---'" :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{pdt.product}}</td>
                    <td>{{pdt.qty}} {{pdt.unit}}</td>
                    <td class="text-sm-end">{{pdt.price}}</td>
                    <td class="text-sm-end">{{pdt.total}}</td>
                  </tr>
                  
                  <tr>
                    <td colspan="4" class="border-0 text-sm-end">
                      <strong>Total</strong>
                    </td>
                    <td class="border-0 text-sm-end">
                      <h4 class="m-0">{{ Invoice.total}}</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-print-none">
              <div class="float-end">
                <a
                  href="javascript:window.print()"
                  class="btn btn-success waves-effect waves-light me-1"
                  ><i class="fa fa-print"></i
                > Print</a>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>